<template>
  <div v-resize="DomResize" class="target-wrap" ref="targetwrapper" 
  :class="getClass(itemInfos) + ' ' + targetRightViewClass('target') + ' ' + (itemInfos.operatorName && itemInfos.editType == 'target' ? 'source-wrap-isEditor' : '')"
>
    <!--标准模式-->
    <!--<template v-if="(editorMode==='standard')">
      <template v-for="(item) in items">
        <span v-if="((item.tagType)==='text')" class="text" :info="getInfo(item,itemInfos)"
              v-html="!!(item.searchState)? item.dataHTML : (item.data.replace(/ /g,'\u00a0') )"/>
        <span v-if="((item.tagType)==='html')" class="text" :info="getInfo(item,itemInfos)"
              v-html="!!(item.searchState)? item.dataHTML : (item.data.replace(/ /g,'\u00a0'))"/>
        &lt;!&ndash;左箭头&ndash;&gt;
        <img alt="此处为链接" :src="getImgInfo(item)" title="此处为链接" :info="getInfo(item,itemInfos)"
             class="tag-img"
             v-if="(item.tagType)==='open'" width="25px"/>
        &lt;!&ndash;定位信息&ndash;&gt;
        <img alt="此处为图片占位标记" :src="position" title="此处为图片占位标记" :info="getInfo(item,itemInfos)"
             v-if="(item.dataType)==='placeholder'" class="placeholder"/>
        &lt;!&ndash;右箭头&ndash;&gt;
        <img alt="此处为链接" :src="getImgInfo(item)" title="此处为链接" :info="getInfo(item,itemInfos)"
             v-if="(item.tagType)==='close'" width="25px"/>
      </template>
    </template>

    &lt;!&ndash;修改痕迹&ndash;&gt;
    <template v-if="(editorMode==='mark')">
      <template v-for="(item) in items">
        <span v-if="((item.tagType)==='text')" class="text" :info="getInfo(item,itemInfos)"
              v-html="!!(item.searchState)? item.dataHTML : (item.data)"/>
        <span v-if="((item.tagType)==='html')" class="text" :info="getInfo(item,itemInfos)"
              v-html="!!(item.searchState)? item.dataHTML : (item.data)"/>
        &lt;!&ndash;左箭头&ndash;&gt;
        <img alt="此处为链接" :src="getImgInfo(item)" title="此处为链接" :info="getInfo(item,itemInfos)"
             v-if="(item.tagType)==='open'" width="25px"/>
        &lt;!&ndash;定位信息&ndash;&gt;
        <img alt="此处为图片占位标记" :src="position" title="此处为图片占位标记" :info="getInfo(item,itemInfos)"
             v-if="(item.dataType)==='placeholder'" style="width:14px" class="placeholder"/>
        &lt;!&ndash;右箭头&ndash;&gt;
        <img alt="此处为链接" :src="getImgInfo(item)" title="此处为链接" :info="getInfo(item,itemInfos)"
             v-if="(item.tagType)==='close'" width="25px"/>
      </template>
    </template>-->
  </div>
  <!--  <div class="df" ref="df" :id="'target-df'+itemInfos.id"></div>-->
</template>

<script>
// import {uuid} from 'vue-uuid';
import { genUUID } from "@/services/common";
import { debounce } from "@/components/editor/common";
import { mapGetters } from 'vuex';

export default {
  name: "ContenteditableTargetHTML",
  props: ['itemInfos', 'flag', 'editorMode', 'isPreMts', 'type'],
  data() {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      correctNodes: [],
      children: [],
      left: require("../assets/images/left.png"),
      right: require("../assets/images/right.png"),
      position: require("../assets/images/position.png"),
      items: [],
      value: "",
      atomMap: {},
      targetDom: null,//tag元素
      cloneDom: null,
      // info:""
    };
  },
  watch: {
    flag: {
      handler(value) {
        if (value === this.itemInfos.id + "target") {
          this.clearCorrect()
        } else if (!value) {
          this.getCorrect()
        }
      },
      deep: true
    },
    editorMode: {
      handler() {
        this.items = this.getListItem();
        if (this.$refs.targetwrapper) {
          this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
          this.renderHtml()
        }
      },
      deep: true
    },
    itemInfos: {
      handler() {
        setTimeout(() => {
          this.getCorrect()
        }, 500)
        this.items = this.getListItem();
        this.renderHtml();
        //修改为 HTML 拼接渲染，解决 v-for 不能清除部分标签
        // if (this.$refs.targetwrapper) {
        //   this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
        // }
      },
      deep: true,
      immediate: true
    },
    getCurrentSentenceIdInfo: {
      handler() {
        //  let timer=setTimeout(()=>{
        this.items = this.getListItem();
        this.bus.$on("changeFlag", (flag) => {
          flag && this.renderHtml();
        })
        // if (this.editorMode === 'mark' && this.$refs.targetwrapper) {
        //   this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
        // }
        //  },1000)
      },
      deep: true,
    },
    getEditorFontSizeInfo: {
      handler(val) {
        if (val) {
          // console.log(val, "val");
          this.getCorrect()
        }
      }
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo'
    ]),
    getCurrentSentenceIdInfo() {
      return this.$store.getters['editor/getCurrentSentenceIdInfo'];
    },
    getLoadingInfo() {
      return this.$store.getters["editor/getLoading"];
    },
    getEditorFontSizeInfo() {
      return this.$store.getters["editor/getEditorFontSizeInfo"];
    },
    getProjectInfo() {
      return this.$store.getters["editor/getProjectInfo"];
    },

  },
  mounted() {
    this.$nextTick(() => {
      if (window.navigator.userAgent.indexOf("MSIE") === -1) {
        this.observer();
      }
      //this.$refs.targetwrapper.innerHTML = this.getRenderHtml();
      this.renderHtml();
      // this.$refs.targetwrapper.childNodes.forEach(item => {
      //   if (item.nodeName === "SPAN") {
      //     item.addEventListener('click', (e) => {
      //       let info = e.target.getAttribute('info')
      //       let key = info.slice(info.indexOf('{') + 1, info.indexOf('}'))
      //       console.log(key, "key");
      //     })
      //   }
      // })
    })
    //   window.setTimeout(() => {
    //   this.$store.dispatch('editor/setTargeteditEditorStatus', 'false')
    // }, 500)
  },
  directives: {
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({ width: style.width, height: style.height });  // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }

        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        // console.log(el, "解绑");
        clearInterval(el.__vueSetInterval__);
      }
    }
  },
  methods: {
    /**
    * @desc 特殊语种样式处理
    * @param {source} 源语言/目标语言
    * @returns {string} 返回样式类名
    */
    targetRightViewClass(source) {
      const { targetLang } = this.getUrlInfo
      if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },
    getListItem() {
      const self = this;
      self.value = self.editorMode
      let newTagTargetSent = Array();
      let reg = /<[^>]+>/g;
      let targetSent = Array();
      let targetHTML = Array();
      let currentSentenceInfo = this.$store.getters['editor/getCurrentSentenceIdInfo'];
      // console.log(currentSentenceInfo.currentId, "currentSentenceInfo.currentId");

      let currentSentenceInfoLength = Object.keys(currentSentenceInfo);
      switch (self.value) {
        case 'standard':
          if (!!(self.itemInfos) && !!(self.itemInfos.tagTargetSent)) {
            const tagTargetSent = (JSON.parse(self.itemInfos.tagTargetSent));
            if (!!tagTargetSent && (tagTargetSent.fragments) && !!(tagTargetSent.fragments.length) && (tagTargetSent.fragments[0].atoms)) {
              targetSent = (tagTargetSent.fragments[0].atoms);
            }
          }
          (targetSent).forEach((item) => {
            if (((item.dataType) === 'text')) {
              if (item.data) {
                // item.data = item.data.replace(/ /g,'\u00a0')
                if (reg.test(item.data)) {
                  let arrEntities = { 'lt': '<', 'gt': '>', 'amp': '&' };
                  let dataHTMLResult = (item.data).replace(/&(lt|gt|amp);/ig, function (all, t) {
                    return arrEntities[t];
                  });
                  Reflect.set(item, 'data', dataHTMLResult);
                }
              }
            }
          });
          newTagTargetSent = [...targetSent];
          return (newTagTargetSent);
        case 'mark':
          // if ((currentSentenceInfoLength.length) && (parseInt(currentSentenceInfo.currentId) === parseInt(self.itemInfos.id))) {
          //   //   console.log('译文-标准');
          //   if (!!(self.itemInfos) && !!(self.itemInfos.tagTargetSent)) {
          //     let tagTargetSent = null;
          //     if (typeof (self.itemInfos.tagTargetSentHtml) === 'string') {
          //       tagTargetSent = (JSON.parse(self.itemInfos.tagTargetSent));
          //     } else {
          //       tagTargetSent = (self.itemInfos.tagTargetSent);
          //     }
          //     if (!!tagTargetSent && (tagTargetSent.fragments) && !!(tagTargetSent.fragments.length) && (tagTargetSent.fragments[0].atoms)) {
          //       targetHTML = (tagTargetSent.fragments[0].atoms);
          //       targetHTML.forEach((item) => {
          //         if (((item.dataType) === 'text')) {
          //           if (!!(item.data)) {
          //             if (reg.test(item.data)) {
          //               let arrEntities = { 'lt': '<', 'gt': '>', 'amp': '&' };
          //               let dataHTMLResult = (item.data).replace(/&(lt|gt|amp);/ig, function (all, t) {
          //                 return arrEntities[t];
          //               });
          //               Reflect.set(item, 'data', dataHTMLResult);
          //             }
          //           }
          //         }
          //       });
          //       newTagTargetSent = [...targetHTML];
          //       targetHTML = newTagTargetSent;
          //     }
          //   }
          // } else {
          // console.log(currentSentenceInfo,"currentSentenceInfo");

          // console.log('译文-修改痕迹');
          if (!!(self.itemInfos) && !!(self.itemInfos.tagTargetSentHtml)) {
            let tagTargetSentHtml = null;
            if (typeof (self.itemInfos.tagTargetSentHtml) === 'string') {
              tagTargetSentHtml = (JSON.parse(self.itemInfos.tagTargetSentHtml));
            } else {
              tagTargetSentHtml = (self.itemInfos.tagTargetSentHtml);
            }
            if (!!tagTargetSentHtml && (tagTargetSentHtml.fragments) && !!(tagTargetSentHtml.fragments.length) && (tagTargetSentHtml.fragments[0].atoms)) {
              targetHTML = (tagTargetSentHtml.fragments[0].atoms);
            }
          }
          // }
          return targetHTML
      }
    },
    reverse(str) {
      // str = str.replace(/</g, "&lt;");
      // str = str.replace(/>/g, "&gt;");
      return str.trim();
    },
    setStyle(str) {
      // console.log(str);
      if (str && this.editorMode === "standard") {
        let arr = str.split(';')
        return arr.filter(item => {
          if (item && item.indexOf('font-size') == -1) {
            return item;
          }
        }).join(";");
      }
    },
    getRenderHtml() {
      let html = "";
      this.atomMap = {};
      let idx = 0;
      this.items.forEach(item => {
        let info = this.getInfo(item, this.itemInfos)
        let style = this.setStyle(item.style) ? this.setStyle(item.style) : "";
        if ((item.tagType) === 'text' || (item.tagType) === 'html') {
          if (style) {
            style = style.replace('color:#FFFFFF', "")
          }
          if (this.editorMode === 'standard') {
            // console.log(item, 111111111);
            if (item.searchState) {
              html += item.dataHTML ? `<span class="text" info="${info}" style='${style}'>${item.dataHTML}</span>` : ''
            } else {
              html += this.reverse(item.data) ? `<span class="text" info="${info}" style='${style}'>${this.reverse(item.data)}</span>` : ''
            }
          } else {
            if (item.searchState) {
              if (item.dataHTML.indexOf('</span>') > -1) {
                html += `${item.dataHTML}`
              } else {
                html += `<span class='equal'>${item.dataHTML}</span>`
              }
            } else {
              if (this.reverse(item.data).indexOf('</span>') > -1) {
                html += `${this.reverse(item.data)}`
              } else {
                html += `<span class='equal'>${this.reverse(item.data)}</span>`
              }
            }
          }
        } else if ((item.tagType) === 'open' || (item.tagType) === 'close') {
          let img = this.getImgInfo(item);
          let id = this.itemInfos.id + item.tagType + idx++;
          this.atomMap[id] = item;
          html += `<img alt="此处为链接" src="${img}" title="此处为链接" info="${info}" class="tag-img" width="25px"  draggable="${this.editorMode === 'standard' ? 'true' : 'false'}" id="target-tag-${id}"/>`
        } else if ((item.tagType) === 'placeholder') {
          let id = this.itemInfos.id + item.tagType + idx++;
          this.atomMap[id] = item;
          html += `<img alt="此处为链接" src="${this.position}" id="target-tag-${id}" title="此处为链接" info="${info}" class="placeholder" draggable="${this.editorMode === 'standard' ? 'true' : 'false'}"/>`
        }
      });
      if(this.itemInfos.operatorName && this.itemInfos.editType == 'target'){
        const editor = this.itemInfos.operatorName
        const isEditHTML = `
          <div class="isedit-box">
            <span class="editor-name">${editor}</span>
            <span class="editor-text">正在编辑...</span>
          </div>`
        return html+isEditHTML;
      }else {
        return html
      }
    },
    renderHtml() {
      let self = this
      //修改为 HTML 拼接渲染，解决 v-for 不能清除部分标签
      if (this.$refs.targetwrapper) {
        this.$refs.targetwrapper.innerHTML = this.getRenderHtml()
        if (navigator.userAgent.indexOf("Firefox") > 0) {
          for (let key in this.atomMap) {
            if (key === undefined) { return }
            self.targetDom = document.getElementById("target-tag-" + key);
            let dragstartLength = [];
            //  拖动tag
            self.targetDom.addEventListener("dragstart", function (event) {
              // console.log("拖动")
              let ele = event.target.parentNode;
              ele.childNodes.forEach(item => {
                if (item.nodeName !== "SPAN") {
                  dragstartLength.push(item)
                }
              })
            });
            self.targetDom.addEventListener("dragend", function (event) {
              let ele = event.target.parentNode;
              let dragendLength = [];
              ele.childNodes.forEach(item => {
                if (item.nodeName !== "SPAN") {
                  dragendLength.push(item)
                }
              })
              if (ele.getAttribute('contenteditable') !== "false") {
                if (dragendLength.length === dragstartLength.length + 1) {
                  event.target.parentNode.removeChild(event.target)
                }
                ele.blur();
                // console.log("拖动完触发");
                setTimeout(() => {
                  self.renderHtml();
                }, 1000)
              }
            });
          }
        }
      }
    },
    DomResize() {
      this.$nextTick(() => {
        if (!this.flag && !this.getLoadingInfo) {
          this.getCorrect()
        }
      })
    },
    //观察器
    observer() {
      const self = this
      const dom = document.getElementById("target-" + self.itemInfos.id)
      const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;//浏览器兼容
      const config = { characterData: true, childList: true, subtree: true }//配置对象
      const callback = function () {
        if (!self.flag && !this.getLoadingInfo) {
          self.getCorrect()
        }
        if (!!document.getElementsByTagName("object") && document.getElementsByTagName("object").length > 0) {
          document.getElementsByTagName("object").forEach(item => {
            item.remove()
          })
        }

      }
      const observer = new MutationObserver(debounce(callback, 100));
      observer.observe(dom, config);
    },
    getCorrect() {
      if (window.navigator.userAgent.indexOf("MSIE") >= 0) {
        return;
      }
      // console.log(this.itemInfos.targetTermSent)
      this.clearCorrect()
      if (!this.itemInfos.targetTermSent || !this.itemInfos.targetTermSent.length) {
        return;
      }
      this.label()
      this.setCorrect()
    },
    //判断选中文本是否换行
    wrapSent(startNode, endNode, start, end, idObj) {
      const range = document.createRange()
      const rangeH = document.createRange()
      // //选择区间
      range.setStart(startNode, start)
      range.setEnd(endNode, end)
      rangeH.setStart(startNode, start)
      rangeH.setEnd(endNode, start + 1)
      const sentHeight = range.getBoundingClientRect().height;
      const textHeight = rangeH.getBoundingClientRect().height;
      let str1 = range.toString().replace(/\u00a0/g, " ")
      let str2 = idObj.text.replace(/\u00a0/g, " ")
      if (str1 !== str2) {
        return false
      }
      if (sentHeight > textHeight) {
        return true
      } else {
        return false
      }
    },
    clearCorrect() {
      const df = document.getElementById("target-df" + this.itemInfos.id)
      if (df) {
        df.innerHTML = "";
      }
    },
    setCorrect() {
      const { targetTermSent ,markTargetTermSent } = this.itemInfos;
      let termSentList
      if(this.editorMode === 'mark'){
        termSentList = markTargetTermSent
      }else if(this.editorMode === 'standard'){
        termSentList = targetTermSent
      }
      if (Array.isArray(termSentList) && termSentList.length) {
        termSentList.forEach(cor => {
          let startNode, endNode, start, end
          this.children.forEach(child => {
            if (cor.textIndex >= child.start && cor.textIndex < child.end && !startNode) {
              startNode = child
            }
            if (cor.textIndex + cor.textLength >= child.start && cor.textIndex + cor.textLength <= child.end && !endNode) {
              endNode = child
            }
          })
          if (startNode && endNode) {
            start = cor.textIndex - startNode.start
            end = cor.textIndex + cor.textLength - endNode.start
            this.correctNodes.push({
              startNode: startNode.node,
              endNode: endNode.node,
              start,
              end,
              index: cor.textIndex
            })
            //console.log(this.correctNodes,'this.correctNodes')
            this.rangeFun(startNode.node, endNode.node, start, end, cor)
          }
        })
      }
    },
    rangeFun(startNode, endNode, start, end, idObj) {
      // console.log(startNode,endNode,start,end,idObj)
      const dom = document.getElementById("target-df" + this.itemInfos.id)
      const domVw = dom.getBoundingClientRect()
      const top = dom.scrollTop
      const range = document.createRange()
      let rangeH
      const isWrap = this.wrapSent(startNode, endNode, start, end, idObj)
      if (isWrap) {
        //  换行选择
        for (let i = start; i < end; i++) {
          range.setStart(startNode, i)
          range.setEnd(endNode, i + 1)
          // this.setRangeDiv(idObj, range, domVw, top, rangeH) // 方法a
          const obj = {
            isFirst: i === start,
            isEnd: i === end - 1,
          };
          this.setRangeDiv(idObj, range, domVw, top,obj);
        }
      } else {
        range.setStart(startNode, start)
        range.setEnd(endNode, end)
        let str1 = range.toString().replace(/\u00a0/g, " ")
        let str2 = idObj.text.replace(/\u00a0/g, " ")
        if (str1 !== str2) return;
        // this.setRangeDiv(idObj, range, domVw, top, rangeH) // 方法a
        const obj = {
          isFirst: true,
          isEnd: true,
        };
        this.setRangeDiv(idObj, range, domVw, top,obj);
      }
    },
    setRangeDiv(idObj, range, domVw, top, isStartOrEnd) {
      // console.log(idObj,range,domVw,top,rangeH)
      const rect = range.getBoundingClientRect()
      const div = document.createElement('div')
      const { isFirst, isEnd } = isStartOrEnd;
      const classNames = ["correct-item"];
      if (isFirst) {
        classNames.push("correct-item-start");
      }
      if (isEnd) {
        classNames.push("correct-item-end");
      }
      div.classList.add(...classNames);
      // div.classList.add('correct-item')
      div.style.pointerEvents = 'auto'
      div.style.left = rect.left - domVw.left + 'px'
      div.style.width = rect.width  + 'px'
      // div.style.height = rect.height + 'px'
      div.style.height = 1 + 'px'
      div.style.top = rect.top + top - domVw.top - 4 + 'px'
      div.style.position = "absolute"
      // div.style.background = "#0167FF"
      div.style.borderTop = "2px solid #ff9c00";
      // div.style.opacity = "0.5"
      const df = document.getElementById("target-df" + this.itemInfos.id)
      df.appendChild(div)
    },
    //数据处理
    label() {
      this.setCorrectHTML()
      const div = document.getElementById("target-" + this.itemInfos.id)
      let children = []
      this.children = []
      this.setTextNode(children, div)
      this.children = children
    },
    //递归获取text节点
    setTextNode(children, div) {
      const childNodes = div.childNodes
      for (let i = 0; i < childNodes.length; i++) {
        const element = childNodes[i]
        if (element.childNodes.length > 1) {
          this.setTextNode(children, element)
        } else if (element.nodeType === 3) {
          const node = element
          const len = children.length ? children[children.length - 1].end : 0
          children.push({ node, start: len, end: node.length + len })
        } else if (element.firstChild && element.firstChild.nodeType === 3) {
          const node = element.firstChild
          const len = children.length ? children[children.length - 1].end : 0
          children.push({ node, start: len, end: node.length + len })
        } else {
          this.setTextNode(children, element)
        }
      }
    },
    setCorrectHTML() {
      this.$nextTick(() => {
        const dom = document.getElementById("target-" + this.itemInfos.id)
        // console.log(dom)
        const h = dom.offsetHeight
        const w = dom.offsetWidth
        const df = document.getElementById(`target-df${this.itemInfos.id}`)
        df.style.height = h + 'px'
        df.style.width = w + 'px'
        df.style.padding = "4px 8px"
      })
    },
    //译文高亮
    getInfo(row, itemInfos) {
      let infos;
      if (Object.keys(row).length) {
        infos = `${(row.atomKey) || (itemInfos.templateKey)}*${(row.dataType) || 'text'}*${(row.id) || `${parseInt((itemInfos.id).toString().substr(0, 5))}`}*${(row.sort) || `${parseInt((itemInfos.id).toString().substr(0, 5))}`}*${(row.style) || 'style'}*${(row.tagType) || 'text'}*${genUUID()}`;
        if (row.dataType === "tag") {
          infos = `${infos}*${(row.data) || 1}`
        }
      }
      return infos
    },

    getClass(row) {
      if (!!row && !!(row.tagTargetSent)) {
        let tagTargetSent = JSON.parse(row.tagTargetSent);
        if (!!tagTargetSent && !!(tagTargetSent.fragments) && !!(tagTargetSent.fragments.length)) {
          let firstChild = tagTargetSent.fragments[0];
          if (!!firstChild && !!(firstChild.atoms) && !!(firstChild.atoms.length)) {
            let firstChildAtoms = firstChild.atoms[0];
            if ((firstChildAtoms.dataType !== 'tag') && !(firstChildAtoms.data)) {
              return 'target-wrap-empty'
            }
          }
        }
      }
      return ''
    },
    getImgInfo(info) {
      if ((info.tagType) === 'open') {
        if (info.data) {
          return info.data < 10 ? require(`../assets/images/left_0${info.data}.png`) : require(`../assets/images/left_${info.data}.png`);
        }
      } else if ((info.tagType) === 'close') {
        if (info.data) {
          return info.data < 10 ? require(`../assets/images/right_0${info.data}.png`) : require(`../assets/images/right_${info.data}.png`);
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.df {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  .correct-item {
    position: absolute;
  }
}

/deep/ .placeholder {
  width: 15px !important;
  z-index: 1000;
}

/deep/ .text {
  word-break: normal !important;
}
.target-wrap{
  word-break: break-all;
}
.source-wrap-isEditor {
  // word-break: break-all;
  padding-bottom: 26px;
  box-sizing: border-box;
}

</style>

<style lang="less">
.isedit-box{
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  right: 10px;
  .editor-name{
    display: inline-block;
    background-color: #fb7333;
    border: 1px solid #d9ecff;
    border-color: #fb7333;
    color: #fff;
    height: 26px;
    padding: 0 10px;
    line-height: 26px;
    font-size: 12px;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 6px;
  }
  .editor-text{
    color: #909399;
    font-size: 12px;
    line-height: 28px;
  }
}
</style>